import React from "react";
import styles from "../Layout.module.css";

const DownloadsPage = (props) => {
  return <div>
    <div className={styles.t2}/>
    <div className={styles.container}>
      <h2>Download Helpers</h2>
      <p>Click on the helper for your operating system.</p>
      <p>This helper ensures that aws credentials will be installed to the correct location.</p>
      <div className={styles.cards}>
        <div className={styles.card}>
          Windows
        </div>
        <div className={styles.spacer}/>
        <div className={styles.card}>
          Mac OS
        </div>
      </div>
    </div>
  </div>;
}

export default DownloadsPage;
